import { CountryConfigurationKeyEnum } from "src/api/configuration/CountryConfigurationEnum";
import { CurrencyCodeEnum } from "src/api/enums/CurrencyCodeEnum";
import { CurrencySymbolEnum } from "src/api/enums/CurrencySymbolEnum";
import { useTranslation } from "src/design-system/core/TranslationContext";
import { useCountryConfiguration } from "src/hooks/useCountryConfiguration";
import { getLocale } from "src/i18n";
import type { FormatterOptions } from "src/utils/formatters";

export interface CurrencyConfig {
    currencyCode: CurrencyCodeEnum;
    currencySymbol: CurrencySymbolEnum;
}

export function useFormatOptions(
    currencyConfig: CurrencyConfig = {
        currencyCode: CurrencyCodeEnum.Euro,
        currencySymbol: CurrencySymbolEnum.Euro,
    }
): FormatterOptions {
    const { t: translateRaw, translateCommon } = useTranslation();
    const { metadata: { currencyCode, currencySymbol } = currencyConfig } =
        useCountryConfiguration(CountryConfigurationKeyEnum.Currency) ?? {};
    const language = getLocale();
    const decimalPart = new Intl.NumberFormat(language)
        .formatToParts(1.1)
        .find((part) => part.type === "decimal");
    const decimalSymbol = decimalPart?.value ?? ".";

    return {
        currencyCode,
        currencySymbol,
        decimalSymbol,
        language,
        translateRaw,
        translateCommon,
    };
}
